"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _themeProvider = require("@mmc/theme-provider");
var _commonCta = require("@mmc/common-cta");
var _calculatorCostBreakdownTable = _interopRequireDefault(require("./calculator-cost-breakdown-table.css"));
var _calculationForm = require("./calculation-form.prop-types");
var CalculatorCostBreakdownTable = function CalculatorCostBreakdownTable(_ref) {
  var onClose = _ref.onClose,
    labels = _ref.labels,
    calculation = _ref.calculation;
  var theme = (0, _themeProvider.useTheme)();
  var tableStyle = (0, _clsx["default"])(theme.table, theme.tableStriped, _calculatorCostBreakdownTable["default"].table);
  var sectionStyle = (0, _clsx["default"])(theme['col-xs-12'], theme['col-md-10'], theme['col-md-offset-1'], _calculatorCostBreakdownTable["default"].section);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _calculatorCostBreakdownTable["default"].calculationOptionsForm
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _clsx["default"])(_calculatorCostBreakdownTable["default"].title, theme.headingTwo)
  }, labels.costBreakDownPopupTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, calculation.breakdown.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: item.title,
      className: sectionStyle
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: _calculatorCostBreakdownTable["default"].sectionTitle
    }, item.title), /*#__PURE__*/_react["default"].createElement("table", {
      className: tableStyle
    }, /*#__PURE__*/_react["default"].createElement("thead", null, /*#__PURE__*/_react["default"].createElement("tr", null, /*#__PURE__*/_react["default"].createElement("th", null, labels.itemColumnLabel), /*#__PURE__*/_react["default"].createElement("th", null, labels.costColumnLabel))), /*#__PURE__*/_react["default"].createElement("tbody", null, item.details.map(function (detail) {
      return (detail == null ? void 0 : detail.value) && (detail == null ? void 0 : detail.label) && /*#__PURE__*/_react["default"].createElement("tr", {
        key: detail == null ? void 0 : detail.label,
        className: theme[detail == null ? void 0 : detail.themeStyle]
      }, /*#__PURE__*/_react["default"].createElement("td", null, detail == null ? void 0 : detail.label), /*#__PURE__*/_react["default"].createElement("td", null, detail == null ? void 0 : detail.value));
    }))));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: theme.row
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-md-6'])
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    clickEvent: onClose,
    classes: _calculatorCostBreakdownTable["default"].closeBtn,
    data: {
      label: labels.returnToCalculatorLabel,
      priority: 'critical'
    }
  }))));
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(CalculatorCostBreakdownTable);